<template>
  <div v-if="selectFieldData">
    <v-list
      class="optionList"
      v-for="(field, index) in selectFieldData"
      :key="field.selection + index"
    >
      <v-layout v-if="field.id == 'weather-city'" row class="main-page-list">
        <v-flex xs12>{{ field.value }}</v-flex>
      </v-layout>
      <home-select-field-item
        v-else-if="
          fieldOptions &&
            field.value !== '' &&
            field.value !== null &&
            field.value !== 'N/A'
        "
        :field-options="fieldOptions"
        :field-data="field"
        :front-data="frontData"
        @saveSelectData="saveData($event, field.selection)"
      />
    </v-list>
  </div>
</template>

<script>
import HomeSelectFieldItem from "./HomeSelectFieldItem";
import { translate } from "../../common/HelperFunctions";

export default {
  name: "HomeSelectLists",
  components: {
    HomeSelectFieldItem
  },
  data: () => ({
    fieldOptions: undefined,
    selectFieldData: undefined
  }),
  props: {
    selectOptions: {
      type: Array,
      default: () => []
    },
    controllerData: {
      type: Array,
      default: () => []
    },
    frontData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    selectOptions: function(newVal) {
      this.fieldOptions = newVal;
    },
    controllerData: function(newVal) {
      this.selectFieldData = newVal;
    }
  },
  async mounted() {
    this.sortFieldOptions();
    this.selectFieldData = this.controllerData;
  },
  methods: {
    // sorting select field items data
    sortFieldOptions() {
      const sortedOptions = this.selectOptions.sort(function(a, b) {
        let valueA = translate(a["@attributes"].txtid);
        let valueB = translate(b["@attributes"].txtid);
        return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
      });
      this.fieldOptions = sortedOptions;
    },
    // function that called in parent to save select field data
    saveData(data, selection) {
      data["selection"] = selection;
      this.$emit("saveSelectFieldData", data);
    }
  }
};
</script>
